import(/* webpackMode: "eager" */ "/workspace/src/app/wolfexpress/page.tsx");
